import { SubmissionMethod } from "encamp-prisma/generated/browser";

/**
 * Helpers for the "Waste Stream Registration" submission type, created from the
 * Waste Streams "needs registration" list (ENG-15415).
 *
 * The submission *type* is always WASTE_STREAM_REGISTRATION; only the submission
 * *method* varies by the facility's state. States without a confirmed portal
 * mapping fall back to PAPER_FORM and stay overridable at create time.
 */

/** Default method when a state has no confirmed portal mapping below. */
export const WASTE_STREAM_REGISTRATION_DEFAULT_SUBMISSION_METHOD = SubmissionMethod.PAPER_FORM;

/**
 * State-specific overrides for where a waste-stream registration is filed.
 * Keyed by two-letter state code. Reconcile TN/SC and any additions with the
 * waste team before enabling unattended auto-assignment.
 */
export const WASTE_STREAM_REGISTRATION_SUBMISSION_METHOD_BY_STATE: Partial<
  Record<string, SubmissionMethod>
> = {
  TX: SubmissionMethod.TX_STEERS_PORTAL,
  MN: SubmissionMethod.MPCA_E_SERVICES,
  KY: SubmissionMethod.KY_GATEWAY_PORTAL,
};

/** Returns the method a waste-stream registration should use for the given state. */
export function getWasteStreamRegistrationSubmissionMethod(
  state?: string | null
): SubmissionMethod {
  if (!state) {
    return WASTE_STREAM_REGISTRATION_DEFAULT_SUBMISSION_METHOD;
  }
  return (
    WASTE_STREAM_REGISTRATION_SUBMISSION_METHOD_BY_STATE[state.toUpperCase()] ??
    WASTE_STREAM_REGISTRATION_DEFAULT_SUBMISSION_METHOD
  );
}

/** Builds the submission title, e.g. "TX Waste Stream Registration — Spent solvents". */
export function buildWasteStreamRegistrationTitle(state: string, streamName: string): string {
  return `${state.toUpperCase()} Waste Stream Registration — ${streamName.trim()}`;
}
